import React from 'react';
import { MenuItem } from '@mui/material';
import { StyledSelect } from './UserAccessItemStyle';
import { GROUP_ROLE_OPTIONS } from 'utils/constant';
import { COLORS } from 'colors';

const RoleSelect = ({ value, onChange, handleRemove, index, disabled = false }) => (
  <StyledSelect value={value} size="small" onChange={onChange} disabled={disabled}>
    {GROUP_ROLE_OPTIONS.map(({ value, label }) => (
      <MenuItem key={value} value={value}>
        {label}
      </MenuItem>
    ))}
    <MenuItem value="remove" style={{ color: COLORS.RED_TEXT }} onClick={() => handleRemove(index)}>
      Remove
    </MenuItem>
  </StyledSelect>
);

export default RoleSelect;
